export default "__VITE_ASSET__Cny7g6nY__"